import {Injectable, Injector} from '@angular/core';
import {
    HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';
import {AuthService} from "./auth.service";
import {ErrorMessageProvider} from "../providers/error.message.provider";

import { environment } from '../../../environments/environment';

@Injectable()
export class RequestsInterceptor implements HttpInterceptor {

    constructor(private injector: Injector, public errorMessageProvider: ErrorMessageProvider) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const auth = this.injector.get(AuthService);

        request = request.clone({
            setHeaders: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + auth.getPassportToken(),
            }
        });

        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                //console.log(event);
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    auth.requestLogin();
                }

                if(err.status === 400){
                    this.errorMessageProvider.show(err.error);
                }

            }
        });
    }
}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/requests.interceptor.ts